import { CateringTranslations } from "./catering-pt-br";

export const CATERING_FR_FR: CateringTranslations = {
	title: "Catering",
	description:
		"Gérez le catering de vos événements, recevez des propositions, envoyez des devis et suivez le tout au même endroit.",
	tabs: {
		proposals: "Propositions",
		settings: "Paramètres",
	},
	settingsMenu: {
		proposalOptions: "Options de propositions",
		servicesAndFormats: "Services et formats",
	},
	feedback: {
		saveSuccess:
			"Modifications enregistrées. Elles s'appliqueront aux nouvelles propositions.",
		saveError:
			"Impossible d'enregistrer les modifications. Veuillez réessayer dans quelques instants.",
	},
	proposalOptions: {
		style: {
			title: "Style de la proposition",
			description: "Personnalisez votre proposition aux couleurs de votre entreprise.",
		},
		company: {
			label: "À propos de l'entreprise",
			companyLabel: "Entreprise",
			editAria: "Modifier les données de l'entreprise",
		},
		infoBlocks: {
			label: "Blocs d'information par défaut",
			showLabel: "Afficher",
			editAria: "Modifier {{name}}",
			disabledHint:
				"Enregistrez les données de l'entreprise avant de configurer ce bloc.",
			header: "En-tête",
			footer: "Pied de page",
			payment: "Moyens et conditions de paiement",
		},
		templates: {
			title: "Modèles de propositions enregistrés",
			description: "Gérez et modifiez vos modèles de proposition.",
			addLabel: "Ajouter un modèle",
			emptyMessage: "Aucun modèle enregistré",
			createdAt: "Créé le {{date}}",
			editAria: "Modifier {{name}}",
		},
	},
	editHeader: {
		title: "Personnaliser l'en-tête",
		createTitle: "Créer l'en-tête",
		saveLabel: "Enregistrer le style",
		fields: {
			title: {
				label: "Titre",
				placeholder: "Ex. : Proposition commerciale",
			},
			showSubmissionDate: "Afficher la date d'envoi et le lieu",
			showCompanyName: "Afficher le nom de l'entreprise demandeuse",
			showRepresentativeName: "Afficher le nom du représentant de l'entreprise",
			text: {
				label: "Texte d'introduction",
				placeholder:
					"Ex. : Chers clients, nous présentons ci-dessous la proposition commerciale selon le calendrier de l'événement.",
				counter: "{{count}}/{{max}} caractères",
			},
		},
	},
	editFooter: {
		title: "Personnaliser le pied de page",
		createTitle: "Créer le pied de page",
		saveLabel: "Enregistrer le style",
		fields: {
			text: {
				label: "Texte de clôture",
				placeholder:
					"Ex. : Merci de votre intérêt, nous restons à votre disposition pour toute question.",
				counter: "{{count}}/{{max}} caractères",
			},
			showResponsibleName: "Afficher le nom du responsable de l'envoi de la proposition",
			showProposalValidity: "Afficher la validité de la proposition",
		},
	},
	editPayment: {
		title: "Personnaliser les moyens et conditions de paiement",
		createTitle: "Créer les moyens et conditions de paiement",
		saveLabel: "Enregistrer le style",
		methods: {
			creditCard: "Carte de crédit",
			debitCard: "Carte de débit",
			boleto: "Boleto bancaire",
			pix: "PIX",
			cash: "Espèces",
		},
		fields: {
			methods: {
				label: "Moyens de paiement acceptés",
			},
			text: {
				label: "Conditions de paiement",
				placeholder:
					"Ex. : Paiement de 70% à la clôture de la proposition et 30% jusqu'à 120 heures avant l'événement;",
				counter: "{{count}}/{{max}} caractères",
			},
		},
	},
	editCompany: {
		title: "Modifier les informations",
		createTitle: "Créer les informations",
		errors: {
			invalidEmail: "E-mail invalide",
			invalidUrl: "Lien invalide",
			requiredName: "Saisissez le nom de l'entreprise",
		},
		saveLabel: "Enregistrer les informations",
		sections: {
			info: "Informations de l'entreprise",
			contacts: "Canaux de contact",
			address: "Adresse",
		},
		fields: {
			name: {
				label: "Nom",
				placeholder: "Saisissez le nom de l'entreprise",
			},
			cnpj: {
				label: "SIRET",
				placeholder: "00.000.000/0000-00",
			},
			site: {
				label: "Site web",
				placeholder: "Collez le lien du site",
			},
			logo: {
				label: "Marque",
				cta: "Ajouter un logo",
				help: "Fichier JPG ou PNG en 300x105px.",
			},
			primaryColor: {
				label: "Couleur principale",
				help: "Choisissez la couleur appliquée aux icônes, textes et boutons.",
				placeholder: "#000000",
			},
			mainPhone: {
				label: "Téléphone principal",
				placeholder: "+33 6 00 00 00 00",
			},
			secondaryPhone: {
				label: "Téléphone secondaire",
				placeholder: "+33 6 00 00 00 00",
			},
			whatsapp: {
				label: "WhatsApp",
				placeholder: "whatsapp.we/9128394",
			},
			email: {
				label: "E-mail",
				placeholder: "contact@entreprise.com",
			},
			socialMedia: {
				label: "Réseau social",
				placeholder: "instagram/entreprise",
			},
			zipCode: {
				label: "Code postal",
				placeholder: "Saisissez le code postal",
			},
			street: {
				label: "Adresse",
				placeholder: "Rue, avenue ou lieu",
			},
			number: {
				label: "Numéro",
				placeholder: "Numéro",
			},
			complement: {
				label: "Complément",
				placeholder: "Complément",
			},
		},
	},
	proposalList: {
		filters: {
			searchPlaceholder: "Rechercher des propositions",
			statusPlaceholder: "Tous les statuts",
			placePlaceholder: "Tous les places",
		},
		columns: {
			representative: "Représentant de l'entreprise",
			place: "Place",
			sentBy: "Envoyé par",
			startsAt: "Commence le",
			servicesCount: "Services",
			servicesTotal: "Montant",
			status: "Statut",
		},
		status: {
			accepted: "Acceptée",
			newResponse: "Nouvelle réponse",
			draft: "Brouillon",
			sent: "Envoyée",
			sendFailed: "Échec de l'envoi",
			rejected: "Refusée",
		},
		emptyMessage: "Aucune proposition trouvée",
	},
	servicesAndFormats: {
		itemsCount: {
			one: "{{count}} élément",
			other: "{{count}} éléments",
		},
		drawerHelperText: "Appuyez sur Entrée pour ajouter à la liste.",
		services: {
			title: "Services enregistrés",
			description:
				"Gérez et enregistrez des services à utiliser lors de la création de propositions.",
			addLabel: "Ajouter un service",
			emptyMessage: "Aucun service enregistré",
			drawer: {
				title: "Ajouter un nouveau service",
				inputLabel: "Nom du service",
				inputPlaceholder: "Saisissez le nom du nouveau service",
				saveLabel: "Enregistrer le service",
			},
			notifications: {
				created: "Service(s) créé(s) avec succès.",
				createdPartial: "{{ok}} service(s) créé(s), {{failed}} en échec.",
				createFailed: "Impossible de créer les services.",
				deleted: "Service supprimé avec succès.",
				deleteFailed: "Impossible de supprimer le service.",
			},
		},
		formats: {
			title: "Formats enregistrés",
			description:
				"Gérez et enregistrez des formats à utiliser lors de la création de propositions.",
			addLabel: "Ajouter un format",
			emptyMessage: "Aucun format enregistré",
			drawer: {
				title: "Ajouter un nouveau format",
				inputLabel: "Nom du format",
				inputPlaceholder: "Saisissez le nom du nouveau format",
				saveLabel: "Enregistrer le format",
			},
			notifications: {
				created: "Format(s) créé(s) avec succès.",
				createdPartial: "{{ok}} format(s) créé(s), {{failed}} en échec.",
				createFailed: "Impossible de créer les formats.",
				deleted: "Format supprimé avec succès.",
				deleteFailed: "Impossible de supprimer le format.",
			},
		},
	},
};
